import {payloadAction} from "utils/stateUtils";

export const APP_SET_PROPS = 'APP_SET_PROPS';

export const setAppProps = payloadAction(APP_SET_PROPS);

